export enum PlanRecurrenceType {
  UNSET_REC_TYPE = 'UNSET_REC_TYPE', // Do not use, needed because of proto3 limitations
  MONTHLY = 'MONTHLY',
  DAILY = 'DAILY',
}
